import { React, useState, useEffect, useRef, useContext } from "react";
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid } from '@mui/x-data-grid';
import PCSelectModal from "../PCSelectModal";

function PurchaseSelectModal({ title, onClose, openType, handlePurchaseClick }) {
  const appStore = useContext(AppContext);
  const searchRef = useRef(null);
  const [keyword, setKeyword] = useState('');
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [originRows, setOriginRows] = useState([]);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
    purchase_name: true,
    purchase_number: true,
    purchase_status: false,
    purchase_status_name: true,
    purchase_date: false,
    purchase_partner_name: true,
    incoming_cnt: false,
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    handleSetting();
    searchRef.current.focus();
    handleView();

    setColumnVisibilityModel({
      id: false,
      purchase_name: true,
      purchase_number: true,
      purchase_status: false,
      purchase_status_name: true,
      purchase_date: false,
      purchase_partner_name: true,
      incoming_cnt: false,
    });
  }, []);


  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  const onSubmitSearch = (e) => {
    //입력 검색어는 Enter로 조회.
    if (e.key === "Enter") {
      handleView();
    }
  };
  
  const handleSetting = () => {
    setColumns([
        { field: 'id', headerName: 'purchase_id', width: 0, headerAlign: 'center' },
        { field: 'purchase_number', headerName: '발주번호', width: 110, headerAlign: 'center', align:'center' },
        { field: 'purchase_status', headerName: 'purchase_status', width: 0, headerAlign: 'center'},
        { field: 'purchase_status_name', headerName: '발주상태', width: 90, headerAlign: 'center', align:'center' },
        { field: 'purchase_name', headerName: '발주명', width: 230, headerAlign: 'center', align:'left' },
        { field: 'purchase_date', headerName: '발주일자', width: 0, headerAlign: 'center', align:'center' },
        { field: 'purchase_partner_name', headerName: '발주처', width: 250, headerAlign: 'center', align:'left' },
        { field: 'incoming_cnt', headerName: 'incoming_cnt', width: 0, headerAlign: 'center'},
    ]);
  }

  const handleView = () => {
    axios.get('/api/p/Purchase/List',
        {
        params : {
          search: keyword
        }
      },
      { withCredentials: true }
    )
    .then((response) => {
        var array = response.data.map((item, index) => ({
            id: item.purchase_id,
            purchase_number: item.purchase_number,
            purchase_status: item.purchase_status,
            purchase_status_name: item.purchase_status_name,
            purchase_date: item.purchase_date,
            purchase_name: item.purchase_name,
            purchase_partner_name: item.purchase_partner_name,
            incoming_cnt: item.incoming_cnt,
        }));
        setOriginRows(response.data);
        if(openType === 'Incoming'){ // 입고에서 해당 모달을 열었을 경우 
          array = array.filter((element) => element.purchase_status === 'S'); // 발주 취소건은 안보이게
          //array = array.filter((element) => element.incoming_cnt === 0); // 이미 참조된 발주건도 안보이게
        }
        setRows([ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse));
    })
    .catch((error) => {
        appStore.capture();
    });
  };

  const handleRowClick = (params) => {
    //부모로 연결된 클릭 이벤트 부모에 handlePurchaseClick 이벤트 만들어 놓아야함.
    let selected_id = params.row.id;
    var selected_row_datas = originRows.filter((item, index) => {
      return typeof item.purchase_id !== 'undefined' && item.purchase_id === selected_id;
    });
    handlePurchaseClick(selected_row_datas);
    onClose?.();
  };

  const handleDelete = () => {
    handlePurchaseClick({
      id: '',
      purchase_id: '',
      purchase_date: '',
      purchase_number: '',
      purchase_partner_id: '',
      purchase_partner_name: '',
      purchase_partner_manager: '',
      purchase_partner_manager_phone: '',
      purchase_partner_manager_mail: ''
    });
    onClose?.();
  };

  return (
    <PCSelectModal onClose={onClose} title={title}>
        <div className="modal" style={{ maxHeight : '435px' }}>
          <table className="SelectModalTABLE">
            <tbody>
            <tr>
              <td className="SelectModalTD" colSpan={2} style={ { padding: '5px' } }>
                <div className="modal_filed_input" style={ { width: 'calc(100% - 190px)', float: 'left' } }>
                  <input type="text" placeholder="검색" value={keyword} name="keyword" onChange={(e) => setKeyword(e.target.value) } onKeyPress={onSubmitSearch} ref={searchRef} autoComplete="off" />
                </div>
                
                <div className="modal_filed_input" style={ { float: 'right' } }>
                  <Button 
                    onClick={handleView}
                    className="btn-p btn-m"
                    sx={{  
                        m: 1, 
                        fontSize: 12, 
                        color: "white", 
                        borderColor: "#3D63AE", 
                        backgroundColor: "#3D63AE",
                        margin: '0px',
                        ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                    }} 
                    variant="outlined">
                    조회
                  </Button>
                </div>
                <div className="modal_filed_input" style={ { float: 'right', paddingRight: '8px' } }>
                  <Button 
                    onClick={handleDelete}
                    className="btn-p btn-m"
                    sx={{  
                        m: 1, 
                        fontSize: 12, 
                        color: "white", 
                        borderColor: "#FF3636", 
                        backgroundColor: "#FF3636",
                        margin: '0px',
                        ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                    }} 
                    variant="outlined">
                    삭제
                  </Button>
                </div>
              </td>
            </tr>
            <tr>
              <td className="SelectModalTD" colSpan={2}>
                <div style={{ padding: '5px', height: '300px' }}>
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    columnVisibilityModel={columnVisibilityModel}
                    onProcessRowUpdateError={(error) => error}
                    AlternatingRowBackground="LavenderBlush"
                    rowsPerPageOptions={[20, 50, 100]}
                    onRowClick={handleRowClick}
                    initialState={{ 
                        density: 'compact'
                    }}
                    slots={{
                        noRowsOverlay: GridNoRow,
                    }}
                    sx={{
                      cursor: "pointer"
                    }}      
                    disableColumnSorting 
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td className="SelectModalTD" colSpan={2}>
                <div className="select_modal_action">
                  <div className="select_modal_button">
                    <Button 
                      onClick={()=> { onClose?.(); }}
                      className="btn-p btn-m"
                      sx={{  
                          m: 1, 
                          fontSize: 12, 
                          color: "white", 
                          borderColor: "#808080", 
                          backgroundColor: "#808080",
                          ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                      }} 
                      variant="outlined">
                      닫기
                    </Button>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
    </PCSelectModal>
  );
}

export default PurchaseSelectModal;